define('presentation/signup/facades/signupPlansFacade',[
    'businessServices/signup/signupSessionSingleton',
    'businessServices/signup/signupSessionStore',
    'common/promises/promiseFactory',
    'persistence/repositories/signupRepository',
    'presentation/signup/presentationObjects/signupPlansPresentationObject'
], function () {
    const PromiseFactoryConstructor = require('common/promises/promiseFactory');
    const _promiseFactory = new PromiseFactoryConstructor();

    const _signupSessionState = require('businessServices/signup/signupSessionSingleton');

    const SignupPlansPresentationObjectConstructor = require('presentation/signup/presentationObjects/signupPlansPresentationObject');

    let _signupRepository = null;
    let _signupSessionStore = null;

    const _getBillingPackages = () => {
        return _promiseFactory.defer((promise) => {
            _signupSessionStore.getBillingPackages()
                .fail(promise.reject)
                .done(promise.resolve);
        });
    };

    const _savePlan = (planId) => {
        return _promiseFactory.defer((promise) => {
            _signupSessionStore.savePlan(planId)
                .fail(promise.reject)
                .done(promise.resolve);
        });
    };

    const _saveTelephonyPackage = (telephonyPackageId) => {
        return _promiseFactory.defer((promise) => {
            _signupSessionStore.saveTelephonyPackage(telephonyPackageId)
                .fail(promise.reject)
                .done(promise.resolve);
        });
    };

    const _saveLiveReceptionistPackage = (liveReceptionistPackageId) => {
        return _promiseFactory.defer((promise) => {
            _signupSessionStore.saveLiveReceptionistPackage(liveReceptionistPackageId)
                .fail(promise.reject)
                .done(promise.resolve);
        });
    };

    const _saveWebChatPackage = (webChatPackageId) => {
        return _promiseFactory.defer((promise) => {
            _signupSessionStore.saveWebChatPackage(webChatPackageId)
                .fail(promise.reject)
                .done(promise.resolve);
        });
    };

    const _saveOutboundCallingPackage = (outboundCallingPackageId) => {
        return _promiseFactory.defer((promise) => {
            _signupSessionStore.saveOutboundCallingPackage(outboundCallingPackageId)
                .fail(promise.reject)
                .done(promise.resolve);
        });
    };

    const _hasOnlyTelephonyPackage = () => {
        const signupDocument = _signupSessionState.signupDocument;
        return !!(signupDocument &&
            signupDocument.telephonyPackageId &&
            !signupDocument.liveReceptionistPackageId &&
            !signupDocument.webChatPackageId &&
            !signupDocument.outboundCallingPackageId);
    };

    const _setPhoneNumberCompleted = (isPhoneNumberCompleted) => {
        return _promiseFactory.defer((promise) => {
            _signupSessionStore.setPhoneNumberCompleted(isPhoneNumberCompleted)
                .fail(promise.reject)
                .done(promise.resolve);
        });
    };

    const _hasLiveReceptionistPackage = () => {
        const signupDocument = _signupSessionState.signupDocument;
        return !!(signupDocument && signupDocument.liveReceptionistPackageId);
    };

    const _isPackageDeepLinked = () => _signupSessionState.isPackageDeepLinked();

    const _setPackageDeepLinked = () => _signupSessionStore.storePackageDeepLinked();

    const _setPlansCompleted = (isPlansCompleted) => {
        return _promiseFactory.deferIndefinitely((promise) => {
            _signupSessionStore.setPlansCompleted(isPlansCompleted)
                .fail(promise.reject)
                .done(promise.resolve);
        });
    };

    const _loadSignupSession = () => {
        return _promiseFactory.defer((promise) => {
            _signupSessionStore.getState()
                .fail(promise.reject)
                .done((signupSession) => {
                    let signupProfilePresentationObject = new SignupPlansPresentationObjectConstructor();
                    signupProfilePresentationObject.affiliateId = signupSession.signupDocument.affiliateId;
                    signupProfilePresentationObject.planId = signupSession.signupDocument.planId;
                    signupProfilePresentationObject.telephonyPackageId = signupSession.signupDocument.telephonyPackageId;
                    signupProfilePresentationObject.liveReceptionistPackageId = signupSession.signupDocument.liveReceptionistPackageId;
                    signupProfilePresentationObject.webChatPackageId = signupSession.signupDocument.webChatPackageId;
                    signupProfilePresentationObject.outboundCallingPackageId = signupSession.signupDocument.outboundCallingPackageId;
                    promise.resolve(signupProfilePresentationObject);
                });
        });
    };

    const _onSignupAffiliateUpdated = (callback) => {
        _signupRepository.onSignupAffiliateUpdated((event) => {
            callback(event);
        });
    };

    const _dispose = () => {
        _signupRepository.dispose();
    };

    const _init = () => {
        const SignupRepository = require('persistence/repositories/signupRepository');
        _signupRepository = new SignupRepository();
        _signupRepository.init();

        const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
        _signupSessionStore = new SignupSessionStoreConstructor();
        _signupSessionStore.init();
    };

    return function () {
        let self = this;
        self.init = _init;

        self.dispose = _dispose;

        self.getBillingPackages = _getBillingPackages;
        self.loadSignupSession = _loadSignupSession;
        self.savePlan = _savePlan;
        self.saveTelephonyPackage = _saveTelephonyPackage;
        self.saveLiveReceptionistPackage = _saveLiveReceptionistPackage;
        self.saveWebChatPackage = _saveWebChatPackage;
        self.saveOutboundCallingPackage = _saveOutboundCallingPackage;
        self.hasLiveReceptionistPackage = _hasLiveReceptionistPackage;
        self.hasOnlyTelephonyPackage = _hasOnlyTelephonyPackage;
        self.isPackageDeepLinked = _isPackageDeepLinked;
        self.setPackageDeepLinked = _setPackageDeepLinked;
        self.setPhoneNumberCompleted = _setPhoneNumberCompleted;
        self.setPlansCompleted = _setPlansCompleted;

        self.onSignupAffiliateUpdated = _onSignupAffiliateUpdated;
    };
});

